import React from 'react';
import './PreparingContent.scss';

interface PreparingContentProps {
  status?: string;
  progress?: number;
}

const PreparingContent: React.FC<PreparingContentProps> = ({ 
  status = 'Preparing your advertisement...', 
  progress = 0 
}) => {
  return (
    <div className="preparing-content">
      <div className="preparing-icon">
        <i className="bi bi-search"></i>
      </div>
      <h2 className="preparing-title">Preparing Your Content</h2>
      <div className="preparing-step">
        <div className="step-icon">
          <div className="spinner"></div>
        </div>
        <div className="step-content">
          <h3 className="animated-message">{status}</h3>
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <p className="step-subtitle">{progress}% complete</p>
        </div>
      </div>
    </div>
  );
};

export default PreparingContent;
